import appConfig from '../../config/appConfig';
import * as muleSoftMethods from '../../consts/muleSoft/muleSoftMethods';
import {updateIotDeviceData} from '../../state/ducks/iotDevice/actions';
import {dispatch} from '../../state/store';
import arrayUtils from '../../utils/arrayUtils';
import stringUtils from '../../utils/stringUtils';
import urlUtils from '../../utils/urlUtils';
import * as gigyaService from '../gigya/gigyaService';
import {consumerAssetsMapping} from '../mapping/muleSoftMarketMapping';
import server from '../server/server';
import muleSoftResponseErrorCheckService from './muleSoftResponseErrorCheckService';

const getConsumerAssets = () =>
    callGet({
        methodName: muleSoftMethods.CONSUMER_DEVICE_HISTORY,
        mapper: consumerAssetsMapping,
        action: updateIotDeviceData,
        throwException: true,
    });

const linkConsumerProduct = (codentify, country) =>
    callPost({
        methodName: muleSoftMethods.LINK_PRODUCT,
        requestConfig: {args: [codentify], data: {country}},
        throwException: true,
    });

const unlinkConsumerProduct = (codentify, country) =>
    callPost({
        methodName: muleSoftMethods.UNLINK_PRODUCT,
        requestConfig: {args: [codentify], data: {country}},
        throwException: true,
    });

const callGet = ({methodName, mapper, action, params, throwException}) => {
    return callRequest({
        httpMethod: server.get,
        methodName,
        requestConfig: params && {params},
        mapper,
        action,
        throwException,
    });
};

const callPost = ({methodName, requestConfig, mapper, throwException}) => {
    return callRequest({
        httpMethod: server.post,
        methodName,
        requestConfig,
        mapper,
        throwException,
    });
};

const callRequest = async ({httpMethod, methodName, requestConfig, mapper, action, throwException = false}) => {
    try {
        const response = await callDmMethod(httpMethod, methodName, requestConfig);

        const {data} = response;

        if (mapper) {
            const mappedData = mapper(data);

            if (action) {
                dispatch(action(mappedData));
            }

            return mappedData;
        } else {
            return httpMethod === server.get ? data : response;
        }
    } catch (e) {
        if (throwException) {
            return Promise.reject(e);
        }
    }
};

const callDmMethod = async (httpMethod, methodName, requestConfig = {}) => {
    const methodUrl = getMuleSoftMarketApiUrl(methodName, requestConfig);

    try {
        const config = await getMuleSoftRequestConfig(requestConfig);

        const response = await httpMethod(methodUrl, config);

        return response;
    } catch (e) {
        const isTokenRefreshed = await muleSoftResponseErrorCheckService(e);

        if (!isTokenRefreshed) return;

        const config = await getMuleSoftRequestConfig(requestConfig);

        return await httpMethod(methodUrl, config);
    }
};

const getParametrizedMethodName = ({methodName, requestConfig}) => {
    const args = requestConfig?.args;
    let methodUrl = methodName;

    if (args) {
        const params = arrayUtils.toArray(args);

        methodUrl = stringUtils.formatString(methodName, ...params);
    }
    return methodUrl;
};

const getMuleSoftMarketApiUrl = (methodName, requestConfig) => {
    const consumerId = gigyaService.getGigyaUid();

    if (!requestConfig?.args) {
        requestConfig.args = [];
    }

    requestConfig?.args?.unshift(consumerId);
    const parametrizedMethodName = getParametrizedMethodName({methodName, requestConfig});

    return urlUtils.join(appConfig.getMuleSoftApiUrl(), parametrizedMethodName);
};

const getMuleSoftRequestConfig = async (requestConfig) => {
    const clientId = appConfig.getMuleSoftClientId();
    const gigyaJWT = gigyaService.getGigyaToken();

    return {
        headers: {jwt: gigyaJWT, client_id: clientId, 'X-Channel': 'WEBSITE'},
        ...requestConfig,
    };
};

export default {
    unlinkConsumerProduct,
    linkConsumerProduct,
    getConsumerAssets,
};
